import { Brain, Paintbrush, Dices, Calculator, Star, Trophy, Medal, Crown, Palette, BookOpen, Sparkles, Zap, Rocket, Flame, CalendarHeart } from "lucide-react";
import { MemoryMatch } from "../components/games/MemoryMatch";
import { ColorSplash } from "../components/games/ColorSplash";
import { StoryDice } from "../components/games/StoryDice";
import { MathPop } from "../components/games/MathPop";
import { StarCatch } from "../components/games/StarCatch";

export const GAME_LIST = [
  { id: "memory", title: "Memory Match", blurb: "Flip cards and find the pairs", icon: Brain, color: "#FF8FC7", Component: MemoryMatch },
  { id: "splash", title: "Color Splash", blurb: "Paint anything you can imagine", icon: Paintbrush, color: "#3DCCC7", Component: ColorSplash },
  { id: "dice", title: "Story Dice", blurb: "Roll silly story ideas", icon: Dices, color: "#FFD23F", Component: StoryDice },
  { id: "math", title: "Math Pop", blurb: "Pop the right answer, fast!", icon: Calculator, color: "#B8F2C9", Component: MathPop },
  { id: "stars", title: "Star Catch", blurb: "Tap the stars before they zoom", icon: Star, color: "#9BD0FF", Component: StarCatch },
];

export const BADGES = {
  first_game: { label: "First Game", icon: Rocket, color: "#FFD23F" },
  star_10: { label: "10 Stars", icon: Star, color: "#FFE58A" },
  star_50: { label: "50 Stars", icon: Medal, color: "#FFB86B" },
  star_100: { label: "Star Legend", icon: Crown, color: "#FF6B4A" },
  memory_master: { label: "Memory Master", icon: Brain, color: "#FF8FC7" },
  artist: { label: "Little Artist", icon: Palette, color: "#3DCCC7" },
  storyteller: { label: "Storyteller", icon: BookOpen, color: "#FFD23F" },
  math_whiz: { label: "Math Whiz", icon: Sparkles, color: "#B8F2C9" },
  star_catcher: { label: "Star Catcher", icon: Zap, color: "#9BD0FF" },
  all_rounder: { label: "All-Rounder", icon: Trophy, color: "#7B5CFA" },
  streak_3: { label: "3-Day Streak", icon: Flame, color: "#FFB86B" },
  streak_7: { label: "7-Day Streak", icon: CalendarHeart, color: "#FF6B4A" },
};

export const BadgeChip = ({ id, size = "md" }) => {
  const b = BADGES[id];
  if (!b) return null;
  const Icon = b.icon;
  return (
    <span data-testid={`badge-${id}`} className={`inline-flex flex-col items-center gap-1 text-center ${size === "sm" ? "w-16" : "w-20"}`}>
      <span className={`grid place-items-center rounded-full border-[3px] border-[#1B1A2E] shadow-[3px_3px_0_0_#1B1A2E] ${size === "sm" ? "w-11 h-11" : "w-14 h-14"}`} style={{ background: b.color }}><Icon size={size === "sm" ? 18 : 24} /></span>
      <span className="font-display text-[11px] font-semibold leading-tight">{b.label}</span>
    </span>
  );
};
